import IconButtonAsLink from './IconButtonAsLink';

export default IconButtonAsLink;
